import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'mt-12 max-md:mt-8',
    container: 'container my-15 max-md:my-8',
    list: 'grid grid-cols-3 gap-x-5 gap-y-10 max-xl:grid-cols-2 max-md:grid-cols-1 max-md:gap-y-2',
    pagination: 'mt-5 flex w-full justify-center',
    showMore: 'mt-5 flex justify-center',
    showMoreButton:
      'bg-bg-items-white heading-s-bold flex-center text-main relative h-[50px] w-full max-w-[600px] cursor-pointer uppercase',
    loading: 'loading absolute opacity-0 transition-opacity',
    loadMoreButtonText: 'transition-opacity',
    requestContainer: 'container mt-6',
    request:
      'grid w-fit grid-cols-[auto_auto_auto] items-center max-sm:w-full max-sm:grid-cols-[auto_auto]',
    requestName: 'heading-2xl order-0 mt-[-6px] mr-3',
    requestLabel: 'px-3 max-sm:order-3',
    requestCancelButton:
      'ml-6 !p-0 max-sm:order-2 max-sm:m-0 max-sm:justify-end',
    requestCancelButtonChildren: 'flex items-center gap-1.5',
    requestCancelButtonIcon: 'mt-[1px] size-5.5',
    stickyFilterPanelContainer: 'w-full bg-white py-2',
    stickyFilterPanel: 'mb-0'
  },
  variants: {
    loadingMore: {
      true: {
        showMoreButton: 'cursor-default',
        loading: 'opacity-100',
        loadMoreButtonText: 'opacity-0'
      }
    }
  }
});
